import { createTheme } from '@mui/material/styles'
import { darkTheme } from './theme/dark'

export const MuiTheme = createTheme({
  components: {
    MuiSkeleton: {
      styleOverrides: {
        root: {
          background: darkTheme.colors.button.secondary.background,
          borderRadius: '12px',
          '&::after': {
            background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent) !important',
            animationDuration: '1.75s',
          },
        },
      },
      defaultProps: { animation: 'wave', variant: 'rounded' },
    },
  },
})
